import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import User from "../../models/user";
import { RootState } from "../store";

interface TestTenant {
    id: string;
    name: string;
}

interface UserState {
    user?: User;
    testTenant?: TestTenant;
}

const initialState: UserState = {
    user: undefined,
    testTenant: undefined,
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        clearUser: () => initialState,
        setTestTenant: (state, action: PayloadAction<TestTenant | undefined>) => {
            state.testTenant = action.payload;
        },
        clearTestTenant: (state) => {
            state.testTenant = undefined;
        },
    },
});

export const { clearUser, setTestTenant, clearTestTenant } = userSlice.actions;
export default userSlice.reducer;

export const selectUser = (state: RootState) => state.user.user;
export const selectTestTenant = (state: RootState) => state.user.testTenant;
